import React from 'react';
import { useDispatch } from 'react-redux';
import Button, {
  BUTTON_COLOR,
  BUTTON_HEIGHT,
  BUTTON_WIDTH,
  BUTTON_OPERATION,
} from '@bit/gerenciatd.unifiedcomponents.button';
import Modal from '@bit/gerenciatd.unifiedcomponents.modal';
import { handlePreventionBehaviour } from '../Utils';
import './StyckyButtonsBar.scss';

/**
 * Componnte que pinta los botones de la modal de retencion
 * @param {obj} taggingInfo info de taggueo
 * @param {obj} taggingInfoClose info de taggueo especifico para cerrar
 * @param {obj} selectedProduct info del producto seleccionado
 * @param {func} downGradeOnclikcHandler func para elegir la accion que desencadena
 * @param {boolean} isPrevention si es prevencion true y si es retencion false
 * @returns {jsx}
 *
 * @Components {null}
 */
const StyckyButtonsBar = ({
  taggingInfo,
  taggingInfoClose,
  selectedProduct,
  downGradeOnclikcHandler,
  isPrevention,
  context,
  retentionOffer,
  productHired,
}) => {
  let url = '';
  if (
    selectedProduct
    && selectedProduct.dataMap
    && selectedProduct.dataMap.urlProdCompra
  ) {
    url = selectedProduct.dataMap.urlProdCompra;
  }

  let urlHired = '';
  if (
    productHired
    && productHired.dataMap
    && productHired.dataMap.urlProdCompra
  ) {
    urlHired = productHired.dataMap.urlProdCompra;
  }

  const taggingInfoCompraRepoDown = {
    ...taggingInfo,
    componentContent: 'interes',
  };

  return (
    <section className="container">
      <div className="styckyButtonsBar">
        <div className="button">
          <Button
            color={BUTTON_COLOR.GREEN_REVERSE}
            label="Continuar compra"
            taggingInfo={{
              ...taggingInfoCompraRepoDown,
            }}
            size={{
              w: BUTTON_WIDTH.LIQUID,
              h: BUTTON_HEIGHT.REGULAR,
            }}
            onClick={() => {
              handlePreventionBehaviour(
                isPrevention,
                downGradeOnclikcHandler,
                url,
                Modal,
                context
              );
            }}
            // Temporaly comented not delete for include in future
            // operation={BUTTON_OPERATION.NO}
          />
        </div>
        <div className="button">
          {!retentionOffer && (
            <Button
              color={BUTTON_COLOR.GREEN}
              label="No me cambio"
              taggingInfo={{
                ...taggingInfoClose,
                componentContent: 'no-me-cambio',
              }}
              size={{
                w: BUTTON_WIDTH.LIQUID,
                h: BUTTON_HEIGHT.REGULAR,
              }}
              // Temporaly comented not delete for include in future
              // operation={BUTTON_OPERATION.NO}
              onClick={() => {
                Modal.hide();
              }}
            />
          )}
          {retentionOffer && (
            <Button
              color={BUTTON_COLOR.GREEN}
              label="Prefiero la oferta"
              taggingInfo={{
                ...taggingInfoCompraRepoDown,
                componentContent: 'prefiero-la-oferta',
              }}
              size={{
                w: BUTTON_WIDTH.LIQUID,
                h: BUTTON_HEIGHT.REGULAR,
              }}
              onClick={() => {
                handlePreventionBehaviour(
                  isPrevention,
                  downGradeOnclikcHandler,
                  urlHired,
                  Modal,
                  context
                );
              }}
              // Temporaly comented not delete for include in future
              // operation={BUTTON_OPERATION.NO}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default StyckyButtonsBar;
